/**
 * GSAP entry: register plugins and initialise animation modules.
 * Each module checks for its own elements and no-ops if not on the page.
 */
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { initHomeHeroVideo } from "./gsap/home-hero-video.js";
import { initTextHeroImage } from "./gsap/text-hero-image.js";
import { initAboutTextParallax } from "./gsap/about-text-parallax.js";
import { initScrollIconsAnimations } from "./gsap/scroll-icons.js";
import { initFloatingDiscussScrollRotation } from "./gsap/floating-discuss.js";
import { initCustomCursorModule } from "./custom-cursor.js";
import { initCaseStudyFilters } from "./gsap/case-study-filters.js";
import { initCaseStudyCardTags } from "./gsap/case-study-card-tags.js";
import { initCaseStudyCardHoverVideo } from "./gsap/case-study-card-hover-video.js";
import { initBlogLoadMore } from "./gsap/blog-load-more.js";
import { initUiBtnHover } from "./gsap/ui-btn-hover.js";
import { initMediaHeroParallax } from "./gsap/media-hero-parallax.js";
import { initVideoHeroParallax } from "./gsap/video-hero-parallax.js";
import { initFullWidthVideo } from "./gsap/full-width-video.js";
import { initTeamGridModals } from "./gsap/team-grid-modal.js";
import { initNavServicesDropdown } from "./gsap/nav-services-dropdown.js";
import { initMobileNav } from "./gsap/mobile-nav.js";
import { initStickyCards } from "./gsap/sticky-cards.js";
import { initBlockScrollReveals } from "./gsap/block-scroll-reveals.js";

gsap.registerPlugin(ScrollTrigger);

function init() {
	// Each init returns early if its elements don't exist
	initHomeHeroVideo();
	initMediaHeroParallax();
	initVideoHeroParallax();
	initFullWidthVideo();
	initTextHeroImage();
	initAboutTextParallax();
	initScrollIconsAnimations();
	initFloatingDiscussScrollRotation();
	initCustomCursorModule();
	initCaseStudyFilters();
	initCaseStudyCardTags();
	initCaseStudyCardHoverVideo();
	initBlogLoadMore();
	initUiBtnHover();
	initTeamGridModals();
	initNavServicesDropdown();
	initMobileNav();
	initStickyCards();
	initBlockScrollReveals();
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
